<div class="label-container" (click)="openSupportDialog.emit()">
    <div class="label-body" [ngStyle]="expanded ? {display: 'none'} : {display: 'flex'}">
        <label class="label">{{ text }}</label>
    </div>
</div>
